// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"S3-z","dimensionLabel":"T3-z","styleChooserControlWrapper":"U3-z","styleChooserControl":"V3-z","disabled":"W3-z","giftCard":"X3-z","styleChooserText":"Y3-z"};